import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=89141d38&"
import script from "./PageBar.vue?vue&type=script&lang=js&"
export * from "./PageBar.vue?vue&type=script&lang=js&"
import style0 from "./PageBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports